<template>
  <div></div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'GoogleGeo',

  mounted () {
    Vue.axios.post(`https://www.googleapis.com/geolocation/v1/geolocate?key=${process.env.VUE_APP_GEOCODING_API}`)
      .then(data => {
        this.geolocation = {
          type: "Point",
          coordinates: [ data.data.location.lng, data.data.location.lat ],
        }
        this.$store.commit('STORE_GEOLOCATION', this.geolocation)
        this.$store.commit('STORE_GEOLOCATION_ACCURACY', data.data.accuracy)
      })
      .catch(err => {
        console.log('error: ', err)
      })
  },
}
</script>

<style lang="scss">

</style>
